(function(){
  function q(root,sel){return root&&root.querySelector(sel)}
  function qa(root,sel){return root?Array.from(root.querySelectorAll(sel)):[]}
  function session(){return window.EDGBuildSession||null}
  function dog(){var s=session();return s?s.activeDog():null}
  function saveSelection(type,d){
    var s=session();if(!s||!s.patchActiveDog)return;
    var patch={product:type};
    if(type==='adapter'){
      if(d&&d.fiSeries==='Fi Mini')patch.adapterFamily='mini-compact';
      else if(d&&d.fiSeries==='Series 3+')patch.adapterFamily=d.behavior==='yes'?'fi3-behavior-or-compact':'fi3-compact-or-behavior';
      else patch.adapterFamily='';
    }
    s.patchActiveDog(patch);
  }
  function esc(value){return String(value==null?'':value).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]})}
  function guidedHref(href){
    if(String(href||'').indexOf('/products/')!==0)return href;
    var text=String(href),hash='',index=text.indexOf('#');
    if(index>=0){hash=text.slice(index);text=text.slice(0,index)}
    return text+(text.indexOf('?')>=0?'&':'?')+'edg_guided=1'+hash;
  }
  function action(href,label,primary){href=guidedHref(href);return '<a class="'+(primary?'edg-route-primary':'')+'" href="'+href+'">'+label+'</a>'}
  function isIntegratedSeries(d){return d&&(d.fiSeries==='Fi 2'||d.fiSeries==='Series 3'||d.fiSeries==='Series 3+')}
  function labelFor(type){return {traditional:'Traditional Buckle',martingale:'Martingale',arctic:'Arctic Circle',inline:'Signature Canvas',adapter:'Fi Adapter'}[type]||type}

  var collarRoutes={
    traditional:{standard:'/products/traditional-buckle-collar',fi:'/products/fi-traditional-buckle-collar',standardLabel:'Traditional Buckle',fiLabel:'Fi Traditional Buckle',handoff:'confirm neck fit, size, width and color'},
    martingale:{standard:'/products/martingale-collar',fi:'/products/fi-martingale-collar#edg-martingale-builder',standardLabel:'Martingale',fiLabel:'Fi Martingale',handoff:'confirm neck and head fit, size, Fi setup and color'},
    arctic:{standard:'/products/arctic-circle-collar',fi:'/products/fi-arctic-circle-collar',standardLabel:'Arctic Circle',fiLabel:'Fi Arctic Circle',handoff:'confirm neck and head fit, size, width and color'},
    inline:{standard:'/products/signature-canvas-collar',fi:'/products/fi-signature-canvas-collar',standardLabel:'Signature Canvas',fiLabel:'Fi Signature Canvas',handoff:'confirm size and pattern'}
  };

  function collarOutcome(type,d){
    var r=collarRoutes[type],out={title:'',copy:'',html:'',summary:labelFor(type)};
    var fi=d.fiStatus==='yes',series=d.fiSeries||'';
    if(type==='inline'){
      if(fi&&isIntegratedSeries(d)){
        out.title=(d.name?'Ready for '+d.name+'’s ':'Ready for your ')+r.fiLabel+'.';
        out.copy='This is the Fi-integrated Signature Canvas path for '+series+'. Continue to confirm the Fi setup, size and pattern.';
        out.html=action(r.fi,'Continue to Fi Signature Canvas →',true);
      }else if(fi&&series==='Fi Mini'){
        out.title=(d.name?'Ready for '+d.name+'’s ':'Ready for your ')+r.standardLabel+'.';
        out.copy='Fi Mini is not integrated into Signature Canvas. Build the standard Signature Canvas collar, then use the Fi Mini Compact Adapter on compatible gear.';
        out.html=action(r.standard,'Build Signature Canvas →',true)+action('/products/fi-mini-compact-adapter','View Mini Compact Adapter →',false);
      }else if(fi&&series==='Fi Ultra'){
        out.title=(d.name?'Ready for '+d.name+'’s ':'Ready for your ')+r.standardLabel+'.';
        out.copy='Fi Ultra does not currently have an EDG integrated Signature Canvas path. The standard Signature Canvas collar remains available without an unsupported Fi promise.';
        out.html=action(r.standard,'Build Signature Canvas →',true);
      }else if(d.fiStatus==='learn'){
        out.title='Choose how you want to explore Signature Canvas.';
        out.copy='Build the standard Signature Canvas collar now, or explore the Fi-integrated version for Fi 2 and Series 3/3+.';
        out.html=action(r.standard,'Build Standard Signature Canvas →',true)+action(r.fi,'Explore Fi Signature Canvas →',false);
      }else{
        out.title=(d.name?'Ready for '+d.name+'’s ':'Ready for your ')+r.standardLabel+'.';
        out.copy='Fi is not part of this setup. Continue with the standard Signature Canvas collar and confirm size and pattern.';
        out.html=action(r.standard,'Continue Building →',true);
      }
      return out;
    }

    if(fi&&isIntegratedSeries(d)){
      out.title=(d.name?'Ready to build '+d.name+'’s ':'Ready to build your ')+r.fiLabel+'.';
      out.copy=series+' is supported on this integrated Fi collar. Continue to '+r.handoff+'.';
      out.html=action(r.fi,'Continue Building →',true);
    }else if(fi&&series==='Fi Mini'){
      out.title=(d.name?'Ready to build '+d.name+'’s ':'Ready to build your ')+r.standardLabel+'.';
      out.copy='Fi Mini is not built directly into this collar. Build the standard collar, then use the Fi Mini Compact Adapter on compatible gear.';
      out.html=action(r.standard,'Build '+r.standardLabel+' →',true)+action('/products/fi-mini-compact-adapter','View Mini Compact Adapter →',false);
    }else if(fi&&series==='Fi Ultra'){
      out.title=(d.name?'Ready to build '+d.name+'’s ':'Ready to build your ')+r.standardLabel+'.';
      out.copy='Fi Ultra does not currently have an EDG integrated collar or adapter path. The standard collar remains available without an unsupported Fi promise.';
      out.html=action(r.standard,'Build '+r.standardLabel+' →',true);
    }else if(d.fiStatus==='learn'){
      out.title='Choose how you want to explore '+r.standardLabel+'.';
      out.copy='You can build the standard collar now or look at the Fi-integrated version. Fi 2 and Series 3/3+ are supported on the integrated build.';
      out.html=action(r.standard,'Build Standard '+r.standardLabel+' →',true)+action(r.fi,'Explore '+r.fiLabel+' →',false);
    }else{
      out.title=(d.name?'Ready to build '+d.name+'’s ':'Ready to build your ')+r.standardLabel+'.';
      out.copy='Fi is not part of this setup. Continue with the standard collar and '+r.handoff+'.';
      out.html=action(r.standard,'Continue Building →',true);
    }
    return out;
  }

  function harnessOnly(d){return d&&d.wear==='harness'&&d.harnessChoice==='harness-only'}
  function adapterOutcome(d){
    var out={title:'Fi Adapter',copy:'',html:'',summary:'Fi Adapter'},series=d.fiSeries||'',fi=d.fiStatus==='yes';
    if(fi&&series==='Fi Mini'){
      out.title='Fi Mini Compact Adapter is the correct adapter path.';
      out.copy='The Mini Compact Adapter can attach Fi Mini to compatible collars or harnesses. Lift-the-DOT hardware is not compatible with Fi Mini.';
      out.html=action('/products/fi-mini-compact-adapter','Continue to Mini Compact Adapter →',true);
      return out;
    }
    if(fi&&series==='Series 3+'){
      if(harnessOnly(d)){
        out.title='Fi 3+ Compact Adapter is the correct harness path.';
        out.copy='Compact supports Fi GPS location and geofence use on a compatible harness. The Behavior Adapter is collar-only, so it is intentionally not offered for this harness-only setup.';
        out.html=action('/products/fi-series-2-3-3-plus-compact-adapter','Continue to Fi 3+ Compact Adapter →',true);
      }else if(d.behavior==='yes'){
        out.title='Fi 3+ Behavior Adapter best matches this setup.';
        out.copy='Because health and behavior tracking matters, use the Behavior Adapter on a compatible collar so the module can sit in the intended position. Compact remains available when GPS/geofence use is the priority.';
        out.html=action('/products/fi-3-behavior-adapter','Continue to Behavior Adapter →',true)+action('/products/fi-series-2-3-3-plus-compact-adapter','Compare Compact Adapter →',false);
      }else if(d.behavior==='unsure'){
        out.title='Both Fi 3+ adapter paths are worth comparing.';
        out.copy='Behavior Adapter is collar-only and preserves the intended behavior-tracking position. Compact works on compatible collars or harnesses for GPS and geofence use.';
        out.html=action('/products/fi-3-behavior-adapter','See Behavior Adapter →',true)+action('/products/fi-series-2-3-3-plus-compact-adapter','See Compact Adapter →',false);
      }else{
        out.title='Fi 3+ Compact Adapter is the simplest starting point.';
        out.copy='Compact works on compatible collars or harnesses for GPS and geofence use. If you want the Fi 3+ behavior-tracking position on a collar, the Behavior Adapter is the alternate path.';
        out.html=action('/products/fi-series-2-3-3-plus-compact-adapter','Continue to Compact Adapter →',true)+action('/products/fi-3-behavior-adapter','See Behavior Adapter →',false);
      }
      return out;
    }
    if(fi&&(series==='Fi 2'||series==='Series 3')){
      out.title=series+' Compact Adapter is the correct adapter path.';
      out.copy='The Compact Adapter can attach '+series+' to a compatible collar or harness for GPS and geofence use. Choose the width that matches the gear your dog already wears.';
      out.html=action('/products/fi-series-2-3-3-plus-compact-adapter','Continue to Compact Adapter →',true);
      return out;
    }
    if(fi&&series==='Fi Ultra'){
      out.title='Fi Ultra adapter accessories are not available yet.';
      out.copy='We are keeping the option visible so the limitation is clear rather than silently removing it.';
      return out;
    }
    if(d.fiStatus==='learn'){
      out.title='Adapters depend on which Fi tracker you choose.';
      out.copy='Fi Mini uses the Mini Compact Adapter. Fi Series 2, Series 3, and Series 3+ use the Compact Adapter; Fi 3+ can also use the collar-only Behavior Adapter.';
      out.html=action('/products/fi-series-2-3-3-plus-compact-adapter','Explore Fi 3+ Compact →',true)+action('/products/fi-mini-compact-adapter','Explore Fi Mini Compact →',false);
      return out;
    }
    out.title='A Fi adapter only makes sense with a compatible Fi tracker.';
    out.copy='Your current setup is not using Fi, so there is no adapter to configure. Go back to the collar choices, or revisit Fi when you decide to add a tracker.';
    return out;
  }

  function outcome(type,d){return type==='adapter'?adapterOutcome(d):collarOutcome(type,d)}

  function routeSlot(root){
    var actions=q(root,'.edg-complete__actions');if(!actions)return null;
    var legacy=q(actions,'a[href="/collections/built-for-fi"]');if(legacy)legacy.hidden=true;
    var buildAnother=q(actions,'[data-build-another]');if(buildAnother)buildAnother.classList.remove('edg-primary');
    var slot=q(actions,'[data-edg-route-actions]');
    if(!slot){slot=document.createElement('div');slot.setAttribute('data-edg-route-actions','');actions.insertBefore(slot,actions.firstChild)}
    return slot;
  }

  function render(root,type){
    var d=dog()||{},complete=q(root,'[data-stage="complete"]');if(!complete)return;
    var result=outcome(type,d),heading=q(complete,'[data-ready-heading]'),copy=q(complete,'[data-ready-copy]'),slot=routeSlot(root),summary=q(complete,'[data-profile-summary]');
    if(heading)heading.textContent=result.title;
    if(copy)copy.textContent=result.copy;
    if(summary){var bits=[];if(d.name)bits.push(d.name);if(d.fiStatus==='yes'&&d.fiSeries)bits.push(d.fiSeries);bits.push(result.summary);summary.innerHTML=bits.map(function(x){return'<span>'+esc(x)+'</span>'}).join('')}
    if(slot)slot.innerHTML=result.html||'';
    complete.hidden=false;complete.scrollIntoView({behavior:'smooth',block:'start'});
  }

  function normalizeCompare(root){
    qa(root,'[data-compare] strong').forEach(function(el){if(el.textContent.trim()==='Inline Fi Collar')el.textContent='Signature Canvas'});
  }

  function decorate(root){
    var d=dog()||{};normalizeCompare(root);
    var inline=q(root,'button[data-product-card][data-value="inline"]');
    if(inline){
      var title=q(inline,'strong');if(title)title.textContent='Signature Canvas';
      var status=q(inline,'[data-product-status]'),text='Standard Signature Canvas • Fi-integrated version available for Fi 2 and Series 3/3+';
      if(d.fiStatus==='yes'&&d.fiSeries==='Fi Mini')text='Standard Signature Canvas available • Fi Mini attaches separately with the Mini Compact Adapter';
      else if(d.fiStatus==='yes'&&d.fiSeries==='Fi Ultra')text='Standard Signature Canvas available • no integrated Fi Ultra claim';
      else if(d.fiStatus==='yes'&&isIntegratedSeries(d))text='Fi-integrated Signature Canvas available for '+d.fiSeries;
      else if(d.fiStatus==='not-currently')text='Standard Signature Canvas available without Fi';
      else if(d.fiStatus==='learn')text='Standard Signature Canvas available • Fi-integrated version supports Fi 2 and Series 3/3+';
      inline.classList.remove('is-unavailable');inline.setAttribute('aria-disabled','false');if(status)status.textContent=text;
    }
    var adapter=q(root,'button[data-product-card][data-value="adapter"]');
    if(adapter){
      var aStatus=q(adapter,'[data-product-status]'),aUnavailable=false,aText='Adapter path depends on Fi tracker, placement and gear width';
      if(d.fiStatus==='yes'&&d.fiSeries==='Fi Mini')aText='Fi Mini Compact Adapter • compatible collar or harness';
      else if(d.fiStatus==='yes'&&d.fiSeries==='Series 3+')aText=harnessOnly(d)?'Fi 3+ Compact Adapter • harness-compatible':'Fi 3+ Compact or Behavior Adapter • placement guidance follows';
      else if(d.fiStatus==='yes'&&(d.fiSeries==='Fi 2'||d.fiSeries==='Series 3'))aText=d.fiSeries+' Compact Adapter • compatible collar or harness'
      else if(d.fiStatus==='yes'&&d.fiSeries==='Fi Ultra'){aUnavailable=true;aText='Fi Ultra accessories coming soon'}
      else if(d.fiStatus==='not-currently'){aUnavailable=true;aText='Requires a compatible Fi tracker • not needed for this non-Fi setup'}
      else if(d.fiStatus==='learn')aText='Available for Fi Series 2, Series 3/3+, and Fi Mini • choose tracker first';
      adapter.classList.toggle('is-unavailable',aUnavailable);adapter.setAttribute('aria-disabled',aUnavailable?'true':'false');if(aStatus)aStatus.textContent=aText;
    }
  }

  function bind(root){
    if(!root||root.dataset.edgRoutingBound)return;root.dataset.edgRoutingBound='true';decorate(root);routeSlot(root);
    root.addEventListener('click',function(e){
      window.setTimeout(function(){decorate(root)},0);
      var b=e.target.closest('[data-product-choice] button[data-value]');if(!b)return;
      var type=b.dataset.value;if(type==='compare')return;
      var d=dog()||{};
      saveSelection(type,d);window.setTimeout(function(){render(root,type)},0);
    });
  }
  function boot(){qa(document,'[data-edg-dog-profile]').forEach(bind)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();